import * as React from 'react';

import user from 'js/lib/user';

import type { SearchHit, SearchProductHit } from 'bundles/search-common/providers/searchTypes';
import useSearchQuery from 'bundles/search-common/providers/useSearchQuery';
import CoursePriceContext from 'bundles/unified-description-page-common/contexts/CoursePriceContext';
import { useCoursePageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffCourseContext';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import getCoursePriceOffer from 'bundles/unified-description-page-common/utils/getCoursePriceOffer';

function isSearchProductHit(hit: SearchHit): hit is SearchProductHit {
  return hit.__typename === 'Search_ProductHit';
}

function isValidSearchHit(pageData?: ConsumerCoursePageFieldsFragment, hit?: SearchProductHit): boolean {
  return (pageData && hit && hit.id?.endsWith(pageData.id)) ?? false;
}

const CoursePriceProvider = ({ children }: { children: React.ReactNode }) => {
  const pageData = useCoursePageData() ?? undefined;
  const skip = !pageData || user.isAuthenticatedUser();
  const { results: searchResult } = useSearchQuery(
    {
      test: {
        id: 'test',
        entityType: 'PRODUCTS',
        limit: 1,
        query: pageData?.name,
        maxValuesPerFacet: 1,
      },
    },
    { skip }
  );

  const hit = searchResult?.[0]?.elements?.[0];

  const pricing =
    hit && isSearchProductHit(hit) && isValidSearchHit(pageData, hit)
      ? getCoursePriceOffer(hit, pageData?.premiumExperienceVariant ?? undefined)
      : undefined;

  return <CoursePriceContext.Provider value={pricing}>{children}</CoursePriceContext.Provider>;
};

export default CoursePriceProvider;
